const encodedDestination = '436+Pottstown+Ave,+Pennsburg,+PA+18073';

export const businessInfo = {
  name: 'Fabulous 10 Nails',
  street: '436 Pottstown Ave.',
  cityStateZip: 'Pennsburg, PA 18073',
  phoneDisplay: '(215) 679-6470',
  phoneHref: 'tel:+12156796470',
  phoneRaw: '+12156796470',
  bookingUrl:
    'https://book.squareup.com/appointments/yvzkpxjnwzqnnb/location/LRZJ8PYM8GKQH',
  googleMapsUrl: `https://www.google.com/maps/dir/?api=1&destination=${encodedDestination}`,
  appleMapsUrl: `https://maps.apple.com/?daddr=${encodedDestination}`,
  directionsUrl: `https://www.google.com/maps/dir/?api=1&destination=${encodedDestination}`,
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3036.698655931788!2d-75.4991616846033!3d40.39331897936784!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c41a0a9a5a67d7%3A0x5b8a0d9a9a9a9a9a!2s436%20Pottstown%20Ave%2C%20Pennsburg%2C%20PA%2018073!5e0!3m2!1sen!2sus!4v1678886400000!5m2!1sen!2sus',
  hours: [
    { label: 'Mon-Thu', time: '10 AM to 7 PM' },
    { label: 'Fri', time: '9 AM to 7 PM' },
    { label: 'Sat', time: '9 AM to 6 PM' },
    { label: 'Sun', time: 'Closed' },
  ],
  servingLine:
    'Serving Pennsburg, Red Hill, Green Lane, East Greenville, Pottstown.',
};

export const popularServices = [
  { name: 'Gel Manicure', price: '$30/up' },
  { name: 'Spa Pedicure', price: '$30/up' },
  { name: 'Deluxe Pedicure', price: '$45/up' },
  { name: 'Dip Full Set', price: '$40/up' },
  { name: 'Acrylic Full Set', price: '$40/up' },
];

export const servicePriceNote =
  'Prices marked with "/up" may vary based on length, design, or requests. Ask your tech for a final total before we begin.';
